import React from "react";
import yellowIndicator from "@src/assets/svg/yellow-indicator-icon.svg";
import { OTAInstallActionButton } from "@src/components/atoms/ota-install-action-button/ota-install-action-button";
import styles from "./ota-pending-approval-by-operator.module.scss";
import { useOtaPendingApprovalByOperator } from "./use-ota-pending-approval-by-operator";
import type { InstallAndActionBlock } from "@src/cloud-connect/ota-update/constants";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";

interface OTAPendingApprovalByOperatorProps {
  activeInstallationData: ActiveInstallationProcessPayload | null;
  setInstallAndActionBlock: React.Dispatch<
    React.SetStateAction<InstallAndActionBlock | null>
  >;
}
const cssClassName = "ota-pending-approval-by-operator";

export default function OTAPendingApprovalByOperator({
  activeInstallationData,
  setInstallAndActionBlock,
}: OTAPendingApprovalByOperatorProps) {
  const { texts, handleCancelRequest, isCancelRequestLoading } =
    useOtaPendingApprovalByOperator({
      activeInstallationData,
      setInstallAndActionBlock,
    });
  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__content`]}>
        <img
          src={yellowIndicator}
          alt=""
          className={styles[`${cssClassName}__indicator`]}
        />
        <div className={styles[`${cssClassName}__text`]}>
          <span className={styles[`${cssClassName}__title`]}>
            {texts.titleHasItemName ? (
              <>
                {texts.titlePrefix}
                <span
                  className={styles[`${cssClassName}__title-item-name`]}
                  title={texts.itemName}
                >
                  {texts.itemName}
                </span>
                {texts.titleSuffix}
              </>
            ) : (
              texts.title
            )}
          </span>
          <span className={styles[`${cssClassName}__description`]}>
            {texts.description}
          </span>
        </div>
      </div>

      <OTAInstallActionButton
        text={texts.cancelRequestButtonText}
        variant="secondary"
        fun={handleCancelRequest}
        disabled={isCancelRequestLoading}
      />
    </div>
  );
}
